module.exports = __webpack_public_path__ + "img/banner@2x.1185c37b.png";